import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { filterDates } from '../../components/FormElements/DateRange';
import { defineds } from 'constants/ui.constants';

interface IReportState {
	error: string | null;
	loading: boolean;
	startDate?: Date | null;
	endDate?: Date | null;
	currentData: any[];
	reportType: string;
}

const yesterday = new Date();
yesterday.setDate(yesterday.getDate() - 1);

const initialState: IReportState = {
	error: null,
	loading: false,
	startDate: yesterday,
	endDate: new Date(),
	currentData: [],
	reportType: '',
};

export const reportSlice = createSlice({
	name: 'reports',
	initialState,
	reducers: {
		setReportType: (state, { payload }) => {
			state.reportType = payload;
		},
		setError: (state, { payload }) => {
			state.error = payload;
		},
		setLoading: (state, { payload }) => {
			state.loading = payload;
		},
		setReportDates: (state, action: PayloadAction<filterDates>) => {
			state.startDate = action.payload.startDate;
			state.endDate = action.payload.endDate;
		},
	},
});

export const { setError, setLoading, setReportType, setReportDates } = reportSlice.actions;

export const getError = (state: any) => {
	return state.reports.error;
};

export const isLoading = (state: any) => state.reports.loading;

export const getCurrentData = (state: any) => state.reports.currentData;

const selectA = (state: any) => state.reports;
export const getReportDates = createSelector([selectA], (state: any) => {
	return { startDate: state.startDate, endDate: state.endDate };
});

export default reportSlice.reducer;
